<template>
	<div class="main-content">
		<section name="header">
			<div class="header-box bg">
				<p>区乡村三级帮办代办数据分析平台</p>
			</div>
		</section>
		<section name="body">
			<div class="body-box bg">
				<div class="title-box">总办件数量</div>
				<div class="info">
					<span style="color: #CCCCCC;">办件数（件）</span>
					<span style="color: #00E4FF;">截止日期：{{ getNowFormatDate() }}</span>
					<span style="color: #FDE17B;">
						<img src="../../assets/img/achievements.png" />
						总数量：{{ sumNumber }}
					</span>
				</div>
				<div class="total" id="total"></div>
			</div>
		</section>
		<section name="footer">
			<div class="footer-box flex space-around">
				<div class="footer-item bg">
					<div class="title-box">办件分析</div>
					<div class="analysis" id="analysis"></div>
				</div>
				<div class="footer-item bg">
					<div class="title-box">帮办小能手</div>
					<div class="content">
						<el-table
							class="personnel-table"
							height="400px"
							:data="staffList"
							style="width: 100%"
						>
							<el-table-column width="100" align="center" label="排名">
								<template slot-scope="scope">
									<div class="no flex space-center" style="height: 28.96px;">
										<img
											style="margin-top: 2px;height: 24px;width: 24px;"
											v-if="scope.$index == 0"
											src="../../assets/img/no-1.png"
										/>
										<img
											style="margin-top: 2px;height: 24px;width: 24px;"
											v-else-if="scope.$index == 1"
											src="../../assets/img/no-2.png"
										/>
										<img
											style="margin-top: 2px;height: 24px;width: 24px;"
											v-else-if="scope.$index == 2"
											src="../../assets/img/no-3.png"
										/>
										<p style="padding: 3px;" v-else>{{ scope.$index + 1 }}</p>
									</div>
								</template>
							</el-table-column>
							<el-table-column width="100" prop="name" align="center" label="姓名">
								<template slot-scope="scope">
									<div style="padding: 3px;">
										{{ scope.row.name }}
									</div>
								</template>
							</el-table-column>
							<el-table-column width="300" prop="village" align="center" label="所属乡镇">
								<template slot-scope="scope">
									<div style="padding: 3px;">
										{{ scope.row.towns + scope.row.village }}
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="footer-item bg long">
					<div class="title-box">办件统计</div>
					<div class="content">
						<div class="business-thead flex align-center" v-if="false">
							<div class="business-td1">申请时间</div>
							<div class="business-td2">业务状态</div>
							<div class="flex-1">业务名称</div>
						</div>
						<vue-seamless-scroll
							:data="businessList"
							ref="seamlessScroll"
							class="business-seamless"
							:class-option="classOption"
							v-if="false"
						>
							<div
								v-for="(item, index) in businessList"
								:key="index"
								class="business-list flex align-center"
							>
								<div class="business-td business-td1">{{ item.create_time }}</div>
								<div class="business-td business-td2">
									<p :style="getColor(item.statusName)">{{ item.statusName }}</p>
								</div>
								<div class="business-td flex-1">
									{{ item.staff_name }}帮{{ item.Apply_object }}办理{{ item.name }}
								</div>
							</div>
						</vue-seamless-scroll>

						<el-table
							v-if="true"
							ref="table"
							class="business-table"
							height="400px"
							:data="businessList"
							style="width: 100%"
						>
							<el-table-column
								width="200px"
								prop="create_time"
								align="center"
								label="申请时间"
							/>
							<el-table-column align="center" label="业务状态">
								<template slot-scope="scope">
									<p :style="getColor(scope.row.statusName)">
										{{ scope.row.statusName }}
									</p>
								</template>
							</el-table-column>
							<el-table-column prop="name" width="400px" align="center" label="业务名称">
								<template slot-scope="scope">
									<!-- <div v-if="scope.row.village == '' || scope.row.village == ''">
										南康区{{ scope.row.staff_name }}帮{{ scope.row.Apply_object }}办理{{
											scope.row.name
										}}
									</div>
									<div v-else-if="scope.row.village != '' && scope.row.village != ''">
										南康区{{ scope.row.staff_name }}帮{{ scope.row.Apply_object }}办理{{
											scope.row.name
										}}
									</div> -->

									<div v-if="scope.row.staff_name != null">
										{{ scope.row.village + scope.row.towns + scope.row.staff_name }}帮{{
											scope.row.Apply_object
										}}办理{{ scope.row.name }}
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import { getBusinessData, getStatistics, staffs, getAnalyses } from '@/api/common'
	import data from '@/const/data'
	import vueSeamlessScroll from 'vue-seamless-scroll'

	export default {
		name: 'index',
		components: {
			vueSeamlessScroll
		},
		data() {
			return {
				sumNumber: 0,
				businessList: [],
				staffList: [],
				businessTimer: null
			}
		},
		computed: {
			classOption() {
				return {
					step: 2, // 数值越大速度滚动越快
					limitMoveNum: 8 // 开始无缝滚动的数据量 this.dataList.length
				}
			}
		},
		watch: {},
		mounted() {
			this.getDataRender()
			setInterval(() => {
				// this.$router.go(0);
				this.getDataRender()
			}, 1000 * 60 * 5)
		},
		methods: {
			getDataRender() {
				this.getStatistics()
				this.staffs()
				this.getBusinessData()
				this.getAnalyses()
			},
			getColor(name) {
				let color = {
					办理中: '#FEE17B',
					已办结: '#19DC7C',
					未受理: '#CCCCCC',
					已驳回: '#FF8A33'
				}
				return `color: ${color[name]}`
			},
			getAnalyses() {
				let analysis = this.$echarts.init(document.getElementById('analysis'))
				let analysisData = data.analysis
				// 使用刚指定的配置项和数据显示图表。
				getAnalyses().then(res => {
					analysisData.series[0].data = res.data.data.map(item => {
						return {
							name: item.name,
							value: item.count
						}
					})
					analysis.setOption(analysisData)
				})
			},
			staffs() {
				staffs().then(res => {
					if (res.data.status == 1) {
						this.staffList = res.data.data || []
						console.log('staffList', this.staffList)
					}
				})
			},
			getNowFormatDate() {
				var date = new Date()
				var seperator1 = '-'
				var year = date.getFullYear()
				var month = date.getMonth() + 1
				var strDate = date.getDate()
				if (month >= 1 && month <= 9) {
					month = '0' + month
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = '0' + strDate
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate
				return currentdate
			},
			getStatistics() {
				let total = this.$echarts.init(document.getElementById('total'))
				let totalData = data.total
				// 使用刚指定的配置项和数据显示图表。
				getStatistics().then(res => {
					let xAxisList = []
					let completeList = []
					let countList = []
					let sunNum = 0
					res.data.data.forEach(item => {
						xAxisList.push(item.village)
						completeList.push(item.complete)
						countList.push(item.count)
						sunNum += parseInt(item.count)
					})
					this.sumNumber = sunNum
					totalData.xAxis[0].data = xAxisList
					totalData.series[0].data = countList
					totalData.series[1].data = completeList
					total.setOption(totalData)
					// this.sumNumber = xAxisList.length;
				})
			},
			getBusinessData() {
				getBusinessData().then(res => {
					if (res.data.status == 1) {
						this.businessList = res.data.data
						console.log('businessList', this.businessList)
						this.businessScroll()
						// this.$refs.seamlessScroll.reset();
					}
				})
			},
			businessScroll() {
				this.$refs.table.bodyWrapper.scrollTop = 0
				if (this.businessTimer) clearInterval(this.businessTimer)
				this.$nextTick(() => {
					let scrollTop = 0
					// 拿到表格挂载后的真实DOM
					const table = this.$refs.table
					// 拿到表格中承载数据的div元素
					const divData = table.bodyWrapper
					this.businessTimer = setInterval(() => {
						// 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
						// 元素自增距离顶部1像素
						scrollTop++
						// scrollTop = scrollTop + 600;
						divData.scrollTop = scrollTop
						// 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
						if (divData.clientHeight + scrollTop >= divData.scrollHeight) {
							// 重置table距离顶部距离
							// divData.scrollTop = 0;
							this.businessScroll()
						}
					}, 200)
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.no {
		align-self: center;
	}
	.main-content {
		color: #fff;
		padding: 10px;
		position: relative;
		font-family: Microsoft YaHei;
		.title-box {
			padding: 25px 0;
			font-size: 24px;
			font-weight: bold;
			color: #00e4ff;
		}
		.bg {
			background-repeat: no-repeat;
			background-position: center;
			background-size: 100% 100%;
		}
		.header-box {
			background-image: url('../../assets/img/header@2x.png');

			height: 70px;
			p {
				font-size: 43px;
				font-weight: bold;
				color: #3d3c3b;
				background: linear-gradient(180deg, #ffffff 0%, #00a8ec 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
		}
		.body-box {
			background-image: url('../../assets/img/bg-body@2x.png');
			height: 440px;
			width: 1860px;
			margin: 0 auto;
			margin-top: 20px;
			position: relative;
			.total {
				width: 100%;
				height: calc(100% - 82px);
			}
			.info {
				position: absolute;
				margin-left: 20px;
				span {
					margin: 0 10px;
					img {
						width: 20px;
						height: 20px;
					}
				}
			}
		}
		.footer-box {
			margin-top: 20px;
			.footer-item {
				width: 500px;
				height: 500px;
				background-image: url('../../assets/img/bg-square@2x.png');
				.content {
					padding: 0 15px;
				}
				.analysis {
					width: 100%;
					height: calc(100% - 82px);
				}
			}
			.long {
				width: 792px;
				background-image: url('../../assets/img/bg-long@2x.png');
			}
		}
	}
	.business-thead {
		height: 50px;
		line-height: 50px;
		background: rgba(0, 228, 255, 0.4);
		color: #ffffff;
		text-align: center;
		font-size: 18px;
		font-weight: bold;
	}
	.business-seamless {
		height: 350px;
		overflow: hidden;
		.business-list {
			border-bottom: 1px solid #8ee3ff;

			.business-td {
				line-height: 23px;
				word-break: break-all;
				padding: 12px 10px;
				box-sizing: border-box;
				color: #cccccc;
			}
		}
	}
	.business-td1 {
		width: 200px;
	}
	.business-td2 {
		width: 145px;
	}
</style>
